import { cn } from "@/lib/utils";

export type ButtonVariant =
  | "primary"
  | "accent"
  | "outline"
  | "ghost"
  | "secondary"
  | "heroOutline";

export type ButtonSize = "sm" | "md" | "lg";

const variants: Record<ButtonVariant, string> = {
  primary:
    "bg-primary text-white hover:bg-primary/90 border border-primary shadow-sm",
  accent:
    "btn-accent bg-accent hover:bg-accent/90 border border-accent font-semibold",
  outline:
    "border border-border text-foreground hover:bg-card bg-transparent",
  ghost: "btn-ghost text-foreground hover:bg-white/10 bg-transparent",
  secondary:
    "bg-card text-foreground hover:bg-background border border-border",
  heroOutline:
    "border border-white/40 text-white hover:bg-white/10 bg-transparent",
};

const sizes: Record<ButtonSize, string> = {
  sm: "px-3 py-1.5 text-sm rounded-lg",
  md: "px-4 py-2.5 text-sm rounded-xl",
  lg: "px-6 py-3 text-base rounded-xl",
};

const base =
  "inline-flex items-center justify-center gap-2 font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:opacity-50 disabled:pointer-events-none";

export function buttonVariants({
  variant = "primary",
  size = "md",
  className,
}: {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
}) {
  return cn(base, variants[variant], sizes[size], className);
}
